import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DocImage = ({ docId, alt, className, testid }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(`/loans/docs/${docId}`, { responseType: "blob" }).then((r) => { url = URL.createObjectURL(r.data); setSrc(url); }).catch(() => {});
    return () => url && URL.revokeObjectURL(url);
  }, [docId]);
  return src ? <img src={src} alt={alt} className={className} data-testid={testid} /> : <div className={`${className} animate-pulse bg-slate-100`} />;
};
